import UsersIndex from './Index';

export default function MembersIndex() {

  return(
    <UsersIndex role="member" />
  )
}
